var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#525252",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 5113 c-105 -7 -325 -45 -450 -77 -342 -89 -689 -264 -975 -492 -105 -84 -294 -272 -380 -378 -295 -365 -486 -809 -551 -1286 -17 -124 -17 -496 0 -620 67 -488 257 -930 565 -1310 77 -96 270 -289 366 -366 380 -308 822 -498 1310 -565 124 -17 496 -17 620 0 477 65 921 256 1286 551 106 86 294 275 378 380 168 211 332 500 422 745 87 238 140 516 150 785 27 708 -241 1386 -746 1890 -528 529 -1239 793 -1995 743z m-292 -1039 c47 -25 1427 -1392 1443 -1431 17 -39 18 -101 4 -140 -12 -32 -1410 -1436 -1452 -1459 -34 -18 -99 -18 -141 0 -18 7 -84 67 -148 132 -133 136 -152 171 -130 246 11 37 80 111 506 538 271 272 500 509 509 527 18 36 21 108 6 150 -6 16 -220 236 -509 523 -446 442 -501 500 -511 538 -20 78 -2 113 124 241 61 62 125 122 141 132 38 24 115 25 158 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.bb6614b372d52a7918a903be42f25fd4.svg";
export { ForwardRef as ReactComponent };